import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="noise relative overflow-hidden bg-navy-deep text-white">
      <div className="flag-stripes h-1.5 w-full opacity-90" />
      <div className="relative z-10 mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <img src="/images/logo-white.png" alt="Future Leaders" className="h-14 w-auto" data-testid="footer-logo" />
            <p className="mt-6 font-serif text-2xl italic leading-snug text-white/85">
              Asegure su ventaja competitiva.
            </p>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-white/50">
              Entrenamiento intensivo de liderazgo y alto rendimiento académico para jóvenes de 14 a 18 años,
              con aval y certificación internacional.
            </p>
          </div>
          <div className="lg:col-span-3">
            <p className="font-mono text-[11px] font-bold uppercase tracking-[0.3em] text-gold">Explorar</p>
            <ul className="mt-6 space-y-3">
              {[
                { to: '/', label: 'Inicio', id: 'inicio' },
                { to: '/seminarios', label: 'Seminarios', id: 'seminarios' },
                { to: '/aval-internacional', label: 'Aval Internacional', id: 'aval' },
              ].map((l) => (
                <li key={l.id}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.id}`}
                    className="group inline-flex items-center gap-2 text-sm text-white/70 transition-colors hover:text-white"
                  >
                    {l.label}
                    <ArrowUpRight className="h-3.5 w-3.5 opacity-0 transition-opacity group-hover:opacity-100" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="lg:col-span-4">
            <p className="font-mono text-[11px] font-bold uppercase tracking-[0.3em] text-gold">Aval internacional</p>
            <ul className="mt-6 space-y-3 text-sm text-white/70">
              <li>American Elite School</li>
              <li>Florida Global University · Licencia #3180</li>
              <li>Center of Education and Leadership</li>
            </ul>
            <div className="mt-6 inline-flex items-center gap-3 rounded-full border border-white/15 px-4 py-2">
              <img src="/images/flag.jpg" alt="Bandera de Estados Unidos" className="h-5 w-8 rounded-[2px] object-cover" />
              <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/60">Avalado en Florida, EE.UU.</span>
            </div>
          </div>
        </div>
        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 sm:flex-row sm:items-center">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/40">
            © 2026 Future Leaders · Un programa de American Elite School
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/40">
            El nivel de los líderes
          </p>
        </div>
      </div>
    </footer>
  );
}
